/***
**Module Name: profile
 **File Name :  profile.js
 **Project :    Dadi
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  Kiran Kumar
 **author :  Mani Kanta
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: 2025-04-22
 **Last modified on: Dec 29 2022
 **Description : contains profile page details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
// import Header from "../components/dashboard/header";
import Header from "../components/dashboard/header";
import SideMenu from "./student/SideMenu";
// import SideMenu from "./student/SideMenu";
import { contentContext } from "../context/contentContext";
// import SessionPopup from "./SessionPopup"
import tmdbApi from "../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import SessionPopup from "./SessionPopup"
import { useNavigate, Link } from "react-router-dom";
import * as Config from "../constants/Config";
import moment from "moment";
import axios from 'axios';

let { lambda, country, appname } = window.app;


const Profile = () => {
    const navigate = useNavigate();
    const [countries, setCountries] = useState('');
    const [idc, setIdc] = useState('');
    const [originalName, setOriginalName] = useState('');

    const { name, setName, userData, setUserData } = useContext(contentContext);
    const [image, setImg] = useState('');

    const [email, setEmail] = useState("");
    const [phonenumber, setPhoneNumber] = useState("");
    const [data, setData] = useState([])
    const [success, setSuccess] = useState(false);
    const [nameerror, setNameError] = useState('');
    const [passwordInput, setPasswordInput] = useState({
        password: '',
        confirmPassword: ''
    })


    const [passwordError, setPasswordErr] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [passwordShown, setPasswordShown] = useState(false);
    const [number, setNumber] = useState(false);
    const [upper, setUpper] = useState(false);
    const [limit, setLimit] = useState(false);
    const [lower, setLower] = useState(false);
    const [special, setSpecial] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [error, setError] = useState('');
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [loaderEnable, setLoaderEnable] = useState("");


    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        streetAddress1: '',
        streetAddress2: '',
        state: '',
        city: '',
        zipCode: '',
        phone: '',
        countryCode: 'IND'
    });

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
        "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
        "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
    ];

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        // GetUserData();

    }, []);



    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);


    const [userType, setUserType] = useState(localStorage.getItem("userType"))
    const GetUserData = async () => {
        try {

            const response = await tmdbApi.getUserData();

            if (response?.statusCode === 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                } else {
                    if (response?.result?.length === 0) {
                        localStorage.clear();
                        navigate("/")
                    } else {
                        setUserData(response?.result?.[0])
                        setName(response?.result?.[0]?.name)
                        setEmail(response?.result?.[0]?.emailid)
                        setData(response?.result?.[0]);
                        setUserType(response?.result?.[0]?.userType)
                        setOriginalName(response?.result?.[0]?.name || '');
                    }
                }
            }
        } catch {
            console.log("error");
        }
    };

    const handleBack = (e) => {
        navigate(-1)
    }

    const handleUserUpdate = (e) => {
        let flag = true;
        if (name === "") {
            setNameError("Please enter name");
            flag = false
            setTimeout(function () { setNameError("") }, 3000);
        }

        if (flag) {
            UpdateForm();
        }

    }

    const UpdateForm = async () => {
        setLoaderEnable("updateForm")
        try {

            const response = await tmdbApi.userDataUpdate({
                "name": name
            });

            if (response?.statusCode === 200) {
                if (response?.result == "Invalid token or Expired") {
                    // setShowSessionPopupup(true)
                    // localStorage.clear();
                    navigate("/")
                } else {
                    setSuccess(true);
                    GetUserData();
                    setLoaderEnable("")
                }
            }
        } catch {
            console.log("error");
        }
    };

    function onConfirm() {
        setSuccess(false)
    };

    const handlePwdGenerate = (e) => {
        const { password, confirmPassword } = passwordInput;

        const errors = [];

        if (!password) {
            errors.push("Please enter new password.");
        } else {
            if (!/[A-Z]/.test(password)) {
                errors.push("Password must contain at least one uppercase letter.");
            }
            if (!/[a-z]/.test(password)) {
                errors.push("Password must contain at least one lowercase letter.");
            }
            if (!/\d/.test(password)) {
                errors.push("Password must contain at least one number.");
            }
            if (!/[#?!@$%^&*-]/.test(password)) {
                errors.push("Password must contain at least one special character.");
            }
            if (password.length < 8) {
                errors.push("Password must be at least 8 characters long.");
            }
        }

        if (!confirmPassword) {
            errors.push("Please confirm your password.");
        } else if (password !== confirmPassword) {
            errors.push("Confirm password does not match.");
        }



        if (errors.length > 0) {
            setError(errors[0]);
            setTimeout(() => setError(""), 3000);
            return;
        }

        // All validations passed
        setError("");
        setConfirmPasswordError("");
        pwdGenerate();
    };

    console.log('userData', userData)


    const pwdGenerate = async () => {
        setLoaderEnable("pwdGenerate")
        try {
            let prams = {
                "emailid": userData?.emailid,
                "password": passwordInput?.password
            }
            const response = await tmdbApi.pwdGenerate(prams);
            console.log(response);


            if (response?.statusCode === 200) {


                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                } else if (response?.result == "old password is wrong") {
                    setLoaderEnable("")
                } else {
                    setSuccess(true);
                    setPasswordInput({ ...passwordInput, password: '', confirmPassword: '' })
                    setLoaderEnable("")
                }

            }


        } catch {
            console.log("error");
        }
    };

    const handlePasswordChange = (evnt) => {

        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
        setPasswordInput(NewPasswordInput);

    }
    const togglePassword = (e) => {
        setPasswordShown(!passwordShown);
    };

    const handleConfirm = (evnt) => {
        const passwordInputFieldName = evnt.target.name;
        if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {

            // if (passwordInput?.confirmPassword !== passwordInput?.password) {
            //     setConfirmPasswordError("Confirm password is not matched");
            // } else {
            //     setConfirmPasswordError("");
            // }

        }
    }

    const RemoveError = () => {
        setPasswordErr("");
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
        validateForm()
    };

    const validateForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formValues.firstName.trim()) errors.firstName = 'First name is required';
        if (!formValues.lastName.trim()) errors.lastName = 'Last name is required';
        if (!emailRegex.test(formValues.email)) errors.email = 'Valid email is required';
        if (!formValues.streetAddress1.trim()) errors.streetAddress1 = 'Street address is required';
        if (!formValues.city.trim()) errors.city = 'City is required';
        if (!formValues.state.trim()) errors.state = 'State is required';
        if (!formValues.zipCode.match(/^\d{6}$/)) errors.zipCode = 'Zip code must be 6 digits';
        if (!formValues.phone.match(/^\d{10}$/)) errors.phone = 'Phone number must be 10 digits';

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleBillingSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {


            try {

                const response = await tmdbApi.userDataUpdate({
                    "billingAddress": formValues
                });

                if (response?.statusCode === 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    } else {
                        setSuccess(true);
                        GetUserData();
                        setLoaderEnable("")
                    }
                }
            } catch {
                console.log("error");
            }

            console.log("Form submitted successfully", formValues);
        } else {
            console.log("Validation failed", formErrors);
        }
    };

    useEffect(() => {
        myArray = localStorage.getItem("ClientName")?.split(" ");


    }, [localStorage.getItem("ClientName")]);

    let myArray = []
    myArray = localStorage.getItem("ClientName")?.split(" ");


    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper" className="profile-db">
                <Header />
                <SideMenu />

                <div className="main-content edit-content user-management profile">

                    <div className="page-content ">
                        <div className="container-fluid">
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">profile</h4>

                                        </div>
                                        <div>
                                            <button onClick={handleBack} className="create-quiz-btn border-0">back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="create-user-block">


                                <div className="form-block">
                                    <div className="row">


                                        <div className="col-md-7 user-details">
                                            <h3>User Details</h3>
                                            <div className="mb-3 row">
                                                <div className="col-md-12">
                                                    <label for="example-text-input" className="col-form-label">NAME</label>
                                                    <input className="form-control" placeholder="Enter Name" type="text" value={name} onChange={(e) => setName(e.target.value)} id="example-text-input" />
                                                    {nameerror ? <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', }}>{nameerror}</span> : ""}
                                                </div>

                                            </div>
                                            <div className="mb-3 row">
                                                <div className="col-md-12">
                                                    <label for="example-text-input" className="col-form-label">EMAIL ID</label>
                                                    <input className="form-control contact-number" type="email" value={userData?.emailid} placeholder=" Enter Company Email" id="example-email-input" disabled />
                                                </div>
                                            </div>




                                            <div className="mb-3 row">
                                                <div className="col-md-12">
                                                    <button onClick={handleUserUpdate} className="btn-fill" disabled={name?.trim() === originalName?.trim()}> UPDATE</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-5 prfile-block">

                                            <div className="avatar-block">
                                                <div className="avatar-header">

                                                    <div className="avatar-img-block"><p>{myArray && myArray.length > 1 ? myArray && myArray.length > 0 && myArray[0]?.slice(0, 1)?.toUpperCase() + myArray[1]?.slice(0, 1)?.toUpperCase()
                                                        : userData && userData?.name?.slice(0, 2)?.toUpperCase()}</p>
                                                    </div>
                                                </div>
                                                <div className="avatar-body">
                                                    <h6 className="username mt-3">{userData?.name}</h6>
                                                    <p className="lg-badge badge">{userData?.userType}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {userData?.userType !== "DOCTOR" &&
                                <div className="create-user-block create-pwd-block">
                                    <div className="form-block">
                                        <h3>Change Password</h3>
                                        <div className="row">
                                            <div className="col-md-7">

                                                <div className="mb-3 row">
                                                    <div className="col-md-12 mb-3">
                                                        <label className="floatingInput">Password<span>*</span></label>
                                                        <input type={passwordShown ? "text" : "password"} value={passwordInput?.password} onChange={(e) => handlePasswordChange(e)} name="password" placeholder="Password" className="form-control" onFocus={RemoveError}
                                                        />
                                                        <p className="text-danger">{passwordError}</p>
                                                    </div>


                                                    <div className="col-md-12 mb-3">
                                                        <label className="floatingInput">Confirm Password<span>*</span></label>
                                                        <input type={passwordShown ? "text" : "password"} value={passwordInput?.confirmPassword} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleConfirm} name="confirmPassword" placeholder="Confirm Password" className="form-control" />
                                                        <p className="text-danger">{confirmPasswordError}</p>


                                                    </div>


                                                    <div className="col-md-12 mb-3">
                                                        <div className="flex-left terms-block"> <input type="checkbox" id="terms-check" checked={passwordShown} onChange={(e) => togglePassword(e)} /><label>Show Password</label></div>
                                                    </div>

                                                    <p className="text-danger">{error}</p>

                                                    <div className="col-md-12">
                                                        <button className="btn-fill" onClick={e => handlePwdGenerate(e)}>CREATE</button>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>



                                    </div>
                                </div>
                            }

                            {/* <div className="create-user-block">


                                <div className="form-block">
                                    <div className="row">

                                        <div className="col-lg-6">
                                            <h6>Billing Address</h6>
                                            <div className="row col-md-12 mt-4">
                                                <div className="col-md-6 mb-3">
                                                    <div className="form_label" id="firstNameGroup">
                                                        <label>First Name</label>
                                                        <input type="text" name="firstName" className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`} value={formValues.firstName} onChange={handleInputChange} />
                                                        {formErrors.firstName && <small className="text-danger">{formErrors.firstName}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form_label" id="lastNameGroup">
                                                        <label>Last Name</label>
                                                        <input type="text" name="lastName" className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`} value={formValues.lastName} onChange={handleInputChange} />
                                                        {formErrors.lastName && <small className="text-danger">{formErrors.lastName}</small>}
                                                    </div></div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="form_label" id="emailGroup">
                                                        <label>Email Address</label>
                                                        <input type="email" name="email" className={`form-control ${formErrors.email ? 'is-invalid' : ''}`} value={formValues.email} onChange={handleInputChange} />
                                                        {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="form_label" id="st1Group">
                                                        <label>Street Address 1</label>
                                                        <input type="text" name="streetAddress1" className={`form-control ${formErrors.streetAddress1 ? 'is-invalid' : ''}`} value={formValues.streetAddress1} onChange={handleInputChange} />
                                                        {formErrors.streetAddress1 && <small className="text-danger">{formErrors.streetAddress1}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="form_label" id="st2Group">
                                                        <label>Street Address 2</label>
                                                        <input type="text" name="streetAddress2" className="form-control" value={formValues.streetAddress2} onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form_label" id="stateGroup">

                                                        <label>State</label>
                                                        <select
                                                            name="state" className={`form-control ${formErrors.state ? 'is-invalid' : ''}`} value={formValues.state} onChange={handleInputChange}
                                                            required
                                                        >
                                                            <option value="">Select State</option>
                                                            {indianStates.sort().map((state, index) => (
                                                                <option key={index} value={state}>
                                                                    {state}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {formErrors.state && <small className="text-danger">{formErrors.state}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form_label" id="cityGroup">

                                                        <label>City</label>
                                                        <input type="text" name="city" className={`form-control ${formErrors.city ? 'is-invalid' : ''}`} value={formValues.city} onChange={handleInputChange} />
                                                        {formErrors.city && <small className="text-danger">{formErrors.city}</small>}
                                                    </div></div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form_label" id="zipGroup">

                                                        <label>Zip Code</label>
                                                        <input type="text" name="zipCode" maxLength="6" className={`form-control ${formErrors.zipCode ? 'is-invalid' : ''}`} value={formValues.zipCode} onChange={handleInputChange} />
                                                        {formErrors.zipCode && <small className="text-danger">{formErrors.zipCode}</small>}
                                                    </div></div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form_label" id="zipGroup">

                                                        <label>Phone Number</label>
                                                        <input type="tel" name="phone" className={`form-control ${formErrors.phone ? 'is-invalid' : ''}`} value={formValues.phone} onChange={handleInputChange} />
                                                        {formErrors.phone && <small className="text-danger">{formErrors.phone}</small>}
                                                    </div></div>



                                                <div className="col-lg-3">
                                                    <button className="create-quiz-btn border-0 mt-3" type="button" onClick={(e) => handleBillingSubmit(e)}>
                                                        Submit
                                                    </button>                                                    </div>
                                            </div>

                                        </div>


                                    </div>

                                </div>
                            </div> */}

                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="Ok"
                        confirmBtnBsStyle="primary"
                        title={"Updated successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>

                    <Footer />
                </div>


            </div>

        </>
    );
};

export default Profile;
